import axios, { AxiosResponse } from 'axios'
import { ID, WoosatTelecomResponse, Response } from '../../../../../_metronic/helpers'
import { Payment, PaymentsQueryResponse } from './_models'
import toast from 'react-hot-toast'

const API_URL = process.env.REACT_APP_THEME_API_URL
const PAYMENT_URL = `${API_URL}/admin/payments`
const GET_PAYMENTS_URL = `${API_URL}/admin/payments`

const getPayments = (query: string): Promise<PaymentsQueryResponse | WoosatTelecomResponse<Payment[]>> => {
  return axios
    .get(`${GET_PAYMENTS_URL}?${query}`)
    .then((d: AxiosResponse<WoosatTelecomResponse<Payment[]>>) => {
      return d.data
    })
}

const getPaymentById = async (id: ID): Promise<Payment> => {
  try {
    const { data } = await axios.get(`${PAYMENT_URL}/${id}`)
    return data?.data?.payment
  } catch (error: any) {
    console.log('Error: ', error.message)
    return {}
  }
}

const createPayment = (payment: Payment): Promise<Payment | undefined> => {
  const formData = new FormData()
  Object.entries(payment).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, value.toString())
    }
  })

  return axios
    .post(PAYMENT_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response: any) => {
      if (response.data.success === true) {
        toast.success(response.data.message, { position: 'top-right' })
      } else {
        toast.error(response?.data?.message, { position: 'top-right' })
      }
      return response.data
    })
    .then((response: Response<Payment>) => response.data)
}

const updatePayment = (payment: Payment): Promise<Payment | undefined> => {
  const newFormData = new FormData()
  Object.entries(payment).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      newFormData.append(key, value.toString())
    }
  })

  return axios
    .post(`${PAYMENT_URL}/${payment.id}`, newFormData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response: any) => {
      if (response.data.success === true) {
        toast.success(response.data.message, { position: 'top-right' })
      } else {
        toast.error(response?.data?.message, { position: 'top-right' })
      }
      return response.data
    })
    .then((response: Response<Payment>) => response.data)
}

const deletePayment = (paymentId: ID): Promise<void> => {
  return axios.delete(`${PAYMENT_URL}/${paymentId}`).then((response) => {
    if (response.data.success === true) {
      toast.success(response?.data?.message, { position: 'top-right' })
    } else {
      toast.error(response?.data?.message, { position: 'top-right' })
    }
  })
}
const rollbackPayment = (paymentId: ID): Promise<void> => {
  return axios.post(`${PAYMENT_URL}/rollback/${paymentId}`).then((response) => {
    if (response.data.success === true) {
      toast.success(response?.data?.message, { position: 'top-right' })
    } else {
      toast.error(response?.data?.message, { position: 'top-right' })
    }
  })
}


const deleteSelectedPayments = (paymentIds: Array<ID>): Promise<void> => {
  const requests = paymentIds.map((id) => axios.delete(`${PAYMENT_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getPayments,
  deletePayment,
  deleteSelectedPayments,
  getPaymentById,
  createPayment,
  updatePayment,
  rollbackPayment
}



